import classnames from 'classnames';
import { ReactNode, useContext } from 'react';
import { ConfigContext } from 'palette/Config';
import type { ModalProps } from 'palette/Modal';
import { Modal, ModalBox, ModalContext } from 'palette/Modal';
import { Transition } from 'palette/Transition';
import { Size } from './constants';
import './styles/Dialog.scss';

interface DialogProps extends ModalProps {
    className?: string;
    size?: Size;
    children: ReactNode;
}

function Dialog({
    children,
    className,
    id,
    preventAutoFocus,
    size = 'medium',
    disablePortal = false,
    disableOutsideClick = false,
    onClose,
}: DialogProps) {
    const { device } = useContext(ConfigContext);
    const { activeModalId } = useContext(ModalContext);
    const classes = classnames(className, 'palette-dialog-modal');
    const dialogBoxRootClass = 'palette-dialog-modal__dialog-box';
    const dialogBoxClasses = classnames(
        dialogBoxRootClass,
        { [`${dialogBoxRootClass}--${device}`]: device },
        `palette-dialog-modal--size-${size}`,
    );
    const isOpen = id === activeModalId;

    return (
        <Modal
            className={classes}
            disableOutsideClick={disableOutsideClick}
            disablePortal={disablePortal}
            id={id}
            preventAutoFocus={preventAutoFocus}
            onClose={onClose}
        >
            <Transition
                appear
                classNames={dialogBoxRootClass}
                property="opacity"
                show={isOpen}
                timeout="quick"
            >
                <ModalBox
                    className={dialogBoxClasses}
                    role="dialog"
                >
                    {children}
                </ModalBox>
            </Transition>
        </Modal>
    );
}

export default Dialog;
